var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a-config-provider", { attrs: { locale: _vm.locale } }, [
    _c(
      "div",
      {
        class: {
          watermark: _vm.appEnv,
          "ios-device": _vm.isIosMobile,
          "android-device": _vm.isAndroidMobile,
          "mobile-device": _vm.isMobile,
          landscape: _vm.isLandscape,
          portrait: _vm.isPortrait,
        },
      },
      [
        _c(
          "span",
          { staticClass: "env-bandage", on: { dblclick: _vm.checkVersion } },
          [_vm._v("\n      " + _vm._s(_vm.appEnv) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "app-container",
            class: { noBorder: !_vm.showHeaderFooter },
          },
          [
            _c("AppHeader", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showHeaderFooter,
                  expression: "showHeaderFooter",
                },
              ],
              ref: "appHeader",
            }),
            _vm._v(" "),
            _c("div", { staticClass: "app-body-container row" }, [
              _c(
                "div",
                { staticClass: "medium-12 small-12 large-12 columns" },
                [
                  _c(
                    "transition",
                    { attrs: { name: "router-fade", mode: "out-in" } },
                    [_c("router-view", { staticClass: "app-body" })],
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("loading", { ref: "loadingLayer" }),
            _vm._v(" "),
            _c("no-perm-modal", { ref: "noPermModal" }),
            _vm._v(" "),
            _c("extend-session-modal", { ref: "extendSessionPermModal" }),
            _vm._v(" "),
            _c("idle-time-check-modal", { ref: "extendSessionPermModal" }),
            _vm._v(" "),
            _vm.showHeaderFooter ? _c("sticky-footer") : _vm._e(),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }